export default __webpack_public_path__ + "static/media/step2.435027b7.svg";